import { Service } from "./service.model";
import { Staff } from "./staff.model";

export interface Salon {
  salon_id: string;
  name: string;
  ownerFirstName?: string;
  ownerLastName?: string;
  businessType?: string;
  description?: string;
  phone: string;
  email: string;
  address: string;
  city: string;
  country: string;
  latitude: number;
  longitude: number;
  is_active?: boolean;
  created_at?: string;
  updated_at?: string;
  is_favorite: boolean;
  tags: string[];
  image?: string;
  rating?: number;
  business?: {
    business_name: string;
    brand_name: string;
    business_type: string;
  };
  services?: Service[];
  staff?: Staff[];
}
export interface Add_Salon {
  salon_id?: number;
  name: string;
  description: string;
  phone: string;
  email: string;
  address: string;
  city: string;

  ownerFirstName?: string;
  ownerLastName?: string;

  state?: string;
  postalCode?: string;
  country?: string;
  latitude: number;
  longitude: number;
  is_favorite: boolean;
  tags: string[];
  businessType?: string;
  yearsInBusiness?: string;
  numberOfStaff?: string;
  images?: [];
}

export interface SalonResponse {
  success?: boolean;
  message?: string;

  count: number;
  next: string | null;
  previous: string | null;

  results: Salon[];
}

export enum SalonMode {
  overview = 0,
  favorite = 1,
}

export enum BookingState {
  cancelled = 0,
  confirmed = 1,
  completed = 2,
  pending = 3,
}

export interface PublicSalon {
  salon_id: string;
  name: string;
  description: string;
  phone: string;
  email: string;
  address: string | null;
  city: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  is_favorite?: boolean;
  business: {
    business_name: string;
    brand_name: string;
    business_type: string;
  };
  services: Array<{
    service_id: string;
    name: string;
    price: string;
    created_at: string;
    updated_at: string;
  }>;
}

export interface SalonReview {
  created_at: string;
  customer: {
    user_id: string;
    full_name: string;
    profile_picture_url: string | null;
  };
  description: string;
  images: any[];
  rating: number;
  review_id: string;
  salon: {
    salon_id: string;
    name: string;
    address: string;
    city: string | null;
  };
  updated_at: string;
}

export interface ReviewApiResponse {
  count: number;
  next: number | null;
  previous: number | null;
  results: SalonReview[];
}
export interface PublicSalonResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: PublicSalon[];
}
